// Auto-generated from lib/i18n.js (mechanical split — do not hand-reorder).
// Namespace "marketplace" base dictionary. New keys for feature batches go in sibling
// fragment files, merged in ./index.js — not here.
export default {
  "fr": {
      "title": "Tout l'écosystème Solunary",
      "subtitle": "Découvrez les praticiens en bien-être, les cours et les produits de la plateforme.",
      "label": "Marketplace",
      "tab.courses": "Cours",
      "tab.products": "Produits",
      "tab.practitioners": "Praticiens",
      "search.products": "Chercher cours, produit, thème…",
      "search.practitioners": "Chercher un praticien…",
      "filter.all": "Tous",
      "filter.free": "Gratuits",
      "filter.paid": "Payants",
      "filter.allPractitioners": "Tous les praticiens",
      "empty": "Aucun résultat pour cette recherche.",
      "card.by": "Par",
      "card.quiz": "quiz",
      "card.free": "Gratuit",
      "card.notAvailableYet": "Pas encore disponible",
      "card.courses": "cours",
      "card.products": "produits"
  },
  "en": {
      "title": "The whole Solunary ecosystem",
      "subtitle": "Discover wellness practitioners, courses and products on the platform.",
      "label": "Marketplace",
      "tab.courses": "Courses",
      "tab.products": "Products",
      "tab.practitioners": "Practitioners",
      "search.products": "Search courses, products, topics…",
      "search.practitioners": "Search a practitioner…",
      "filter.all": "All",
      "filter.free": "Free",
      "filter.paid": "Paid",
      "filter.allPractitioners": "All practitioners",
      "empty": "No results for this search.",
      "card.by": "By",
      "card.quiz": "quiz",
      "card.free": "Free",
      "card.notAvailableYet": "Not available yet",
      "card.courses": "courses",
      "card.products": "products"
  },
  "es": {
      "title": "Todo el ecosistema Solunary",
      "subtitle": "Descubra los profesionales de bienestar, cursos y productos de la plataforma.",
      "label": "Marketplace",
      "tab.courses": "Cursos",
      "tab.products": "Productos",
      "tab.practitioners": "Profesionales",
      "search.products": "Buscar cursos, productos, temas…",
      "search.practitioners": "Buscar un profesional…",
      "filter.all": "Todos",
      "filter.free": "Gratis",
      "filter.paid": "De pago",
      "filter.allPractitioners": "Todos los profesionales",
      "empty": "Sin resultados para esta búsqueda.",
      "card.by": "Por",
      "card.quiz": "quiz",
      "card.free": "Gratis",
      "card.notAvailableYet": "Aún no disponible",
      "card.courses": "cursos",
      "card.products": "productos"
  },
};
